// extracted by mini-css-extract-plugin
export var blockedMessage = "_79-3";
export var blockedOverlay = "_79-1";
export var fadeIn = "_79-2";
export var hereLink = "_79-0";
export var slideUp = "_79-4";